import React, { useState, useEffect, useRef } from 'react';
import { firestore } from '../config/firebaseConfig';
import { doc, setDoc, updateDoc, collection, getDocs, deleteDoc, query, where } from 'firebase/firestore';
import PilulaList from './PilulaList';
import PilulaDetails from './PilulaDetails';
import ConfirmationModal from '../components/ConfirmationModal';
import EmojiList from '../components/EmojiList';
import './Pilulas.css';
import ImportPillsModal from '../components/ImportPillsModal';
import { FcSearch } from "react-icons/fc";
import { Timestamp } from 'firebase/firestore';
import EnviarPilula from '../components/EnviarPilula';
import Modal from 'react-modal';

const ITEMS_PER_PAGE = 2000;

function Pilulas() {
  const [formData, setFormData] = useState({
    titulo: '',
    conteudo: '',
    tipo: '', 
    temas: [],
    dataexpiracao: '',
    prioridade: 0
  });
  const [temas, setTemas] = useState([]);
  const [selectedPilula, setSelectedPilula] = useState(null);
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [pilulas, setPilulas] = useState([]);
  const [filteredPilulas, setFilteredPilulas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [pilulaToDelete, setPilulaToDelete] = useState(null);
  const [isEmojiListVisible, setIsEmojiListVisible] = useState(false);
  const [isImportPillsModalVisible, setIsImportPillsModalVisible] = useState(false);
  const [isEnviarPilulaModalVisible, setIsEnviarPilulaModalVisible] = useState(false);

  const [currentPage, ] = useState(1);
  
  // Obter o tenantId do localStorage
  const tenantId = localStorage.getItem('tenantId') || 'unknownTenant';
 

  const openEnviarPilulaModal = () => {
    setIsEnviarPilulaModalVisible(true);
  };

  const closeEnviarPilulaModal = () => {
    setIsEnviarPilulaModalVisible(false);
  };

  useEffect(() => {
    const fetchPilulas = async () => {
      setIsLoading(true);      
      try {
        // Buscar pílulas filtradas pelo tenantId
        const pilulasQuery = query(collection(firestore, 'pilulas'), where('tenantId', '==', tenantId));
        const querySnapshot = await getDocs(pilulasQuery);
        const pilulasData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        const updatedPilulasData = pilulasData.map(pilula => {
          const temaNomes = pilula.temas.map(temaId => {
            const tema = temas.find(t => t.id === temaId);
            return tema ? tema.nome : 'Tema desconhecido';
          });
            
          return {
            ...pilula,
            temas: temaNomes,
          };
        });
  
        setPilulas(updatedPilulasData);
        setFilteredPilulas(updatedPilulasData);
      } catch (error) {
        console.error('Erro ao buscar pílulas educacionais:', error);
        setError('Não foi possível carregar as pílulas educacionais.');
      } finally {
        setIsLoading(false);
      }
    };

    const fetchTemas = async () => {
      try {
        // Buscar temas filtrados pelo tenantId
        const temasQuery = query(collection(firestore, 'temas'), where('tenantId', '==', tenantId));
        const querySnapshot = await getDocs(temasQuery);
        const temasData = querySnapshot.docs.map(doc => ({ id: doc.id, nome: doc.data().nome }));
        setTemas(temasData);
      } catch (error) {
        console.error('Erro ao carregar temas:', error);
        setError('Não foi possível carregar os temas.');
      }
    };
  
    fetchTemas();
    fetchPilulas();
  }, [tenantId]);

  useEffect(() => {
    applySearchFilter(searchQuery, pilulas);
  }, [searchQuery, pilulas]);
  
  useEffect(() => {}, [filteredPilulas]);
  
  const handleSearch = (e) => {
    const searchText = e.target.value;
    setSearchQuery(searchText);
    applySearchFilter(searchText, pilulas);
  };
  
  const applySearchFilter = (searchText, pilulasData) => {
    let filteredData = pilulasData;
  
    if (searchText.trim()) {
      filteredData = pilulasData.filter(pilula =>
        pilula.titulo.toLowerCase().includes(searchText.toLowerCase()) ||
        pilula.id.includes(searchText)
      );
    }
    setFilteredPilulas(filteredData);
  };

  useEffect(() => {
    if (selectedPilula) {
      setFormData({
        titulo: selectedPilula.titulo || '',
        conteudo: selectedPilula.conteudo || '',
        tipo: selectedPilula.tipo || '',
        temas: selectedPilula.temas || [],
        dataexpiracao: selectedPilula.dataexpiracao || '',
      });
    } else {
      resetFormData();
    }
  }, [selectedPilula]);

  const resetFormData = () => {
    setFormData({
      titulo: '',
      conteudo: '',
      tipo: '',
      temas: [],
      dataexpiracao: '',
      prioridade: 0
    });
    setStep(0);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'temas') {
      const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
      setFormData(prevData => ({ ...prevData, temas: selectedOptions }));
    } else {
      setFormData(prevData => ({ ...prevData, [name]: value }));
    }

    setError('');
  };

  const handleNext = () => {
    const currentStep = steps[step];
    if (currentStep.inputProps.required && !formData[currentStep.inputProps.name]) {
      setError(`Por favor, preencha o campo "${currentStep.label}".`);
      return;
    }

    if (step < steps.length - 1) {
      setStep(step + 1);
    } else {
      handleSubmit();
    }
  };

  const handlePrevious = () => {
    if (step > 0) {
      setStep(step - 1);
    }
  };

  const handleSubmit = async () => {
    if (!formData.titulo || !formData.conteudo || !formData.temas.length || !formData.tipo) {
      setError('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    const updatedData = {
      ...formData,
      updatedAt: Timestamp.now(),
      tenantId, // Adiciona o tenantId ao documento
      enviado: false,
      bloqueado: false,
      prioridade: formData.prioridade || 0 // Garante que sempre tenha um valor

    };

    try {
      if (selectedPilula?.id) {
        await updateDoc(doc(firestore, 'pilulas', selectedPilula.id), updatedData);
      } else {
        await setDoc(doc(firestore, 'pilulas', new Date().getTime().toString()), {
          ...updatedData,
          createdAt: Timestamp.now(),
        });
      }
      setSuccess('Pílula educacional salva com sucesso!');
      resetFormData();
      setSelectedPilula(null);
      setIsCreating(false);
      setTimeout(() => setSuccess(''), 3000);

      const querySnapshot = await getDocs(collection(firestore, 'pilulas'));
      const pilulasData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setPilulas(pilulasData);
      applySearchFilter(searchQuery, pilulasData);
    } catch (error) {
      console.error('Erro ao salvar pílula educacional:', error);
      setError('Houve um problema ao salvar a pílula educacional. Por favor, tente novamente.');
    }
  };

  const handleEdit = (pilula) => {
    setSelectedPilula(pilula);
    setIsCreating(true);
  };

  const handleDelete = async () => {
    if (pilulaToDelete) {
      const protectedId = '1728521579467';

      if (pilulaToDelete.trim() === protectedId) {
        setError('Este convite não pode ser excluído.');
        return;
      }

      try {
        await deleteDoc(doc(firestore, 'pilulas', pilulaToDelete));

        const updatedPilulas = pilulas.filter(pilula => pilula.id !== pilulaToDelete);
        setPilulas(updatedPilulas);

        applySearchFilter(searchQuery, updatedPilulas);

        setIsModalVisible(false);
        setPilulaToDelete(null);
      } catch (error) {
        console.error('Erro ao excluir pílula educacional:', error);
        setError('Houve um problema ao excluir a pílula educacional. Por favor, tente novamente.');
      }
    }
  };

  const handleCancelDelete = () => {
    setPilulaToDelete(null);
    setIsModalVisible(false);
  };

  const steps = [
    { label: 'Título', inputProps: { name: 'titulo', type: 'text', value: formData.titulo, required: true } },
    { label: 'Conteúdo', inputProps: { name: 'conteudo', type: 'textarea', value: formData.conteudo, required: true } },
    { label: 'Tema(s)', inputProps: { name: 'temas', type: 'select', value: formData.temas, required: true, options: temas } },
    { label: 'Tipo', inputProps: { name: 'tipo', type: 'select', value: formData.tipo, required: true, options: ['Vídeo', 'Texto'] } },
    { label: 'Data de expiração', inputProps: { name: 'dataexpiracao', type: 'date', value: formData.dataexpiracao } },
  ];

  const currentStep = steps[step];
  const progressPercentage = ((step + 1) / steps.length) * 100;

  const isContinueEnabled = () => {
    const value = formData[currentStep.inputProps.name];
    return typeof value === 'string' ? value.trim() !== '' : value.length > 0;
  };

  const getInstructionMessage = () => {
    if (step === 0) return "Por favor, insira o título da pílula.";
    if (step === 1) return "Agora, insira o conteúdo da pílula.";
    if (step === 2) return "Pressione a tecla Ctrl para selecionar mais de um tema.";
    if (step === 3) return "Escolha o tipo da pílula.";
    return "Este campo é opcional.";
  };

  const inputRef = useRef(null);

  const handleEmojiSelect = (emoji) => {
    setFormData(prevData => ({
      ...prevData,
      conteudo: prevData.conteudo + emoji
    }));
    setIsEmojiListVisible(false);
  };

  const toggleEmojiList = () => {
    setIsEmojiListVisible(prev => !prev);
  };

  const openImportPillsModal = () => {
    setIsImportPillsModalVisible(true);
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <div className="pilulas-container">
      {isImportPillsModalVisible ? (
        <ImportPillsModal onClose={() => setIsImportPillsModalVisible(false)} />
      ) : isCreating ? (
        <div className="pilula-form-container">
          <div className="instruction-message">
            {getInstructionMessage()}
          </div>
          <div className="progress-bar">
            <div className="progress" style={{ width: `${progressPercentage}%` }}></div>
          </div>
          <form className="pilula-form" onSubmit={(e) => e.preventDefault()}>
            <div className="form-group">
              <label htmlFor={currentStep.inputProps.name}>{currentStep.label}</label>
              {currentStep.inputProps.type === 'select' ? (
                currentStep.inputProps.name === 'temas' ? (
                  <select
                    id={currentStep.inputProps.name}
                    name={currentStep.inputProps.name}
                    value={formData.temas || []}
                    onChange={handleChange}
                    multiple
                  >
                    {temas.map(tema => (
                      <option key={tema.id} value={tema.id}>{tema.nome}</option>
                    ))}
                  </select>
                ) : (
                  <select
                    id={currentStep.inputProps.name}
                    name={currentStep.inputProps.name}
                    value={formData.tipo || ''}
                    onChange={handleChange}
                  >
                    <option value="">Selecione</option>
                    {currentStep.inputProps.options.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                )
              ) : currentStep.inputProps.type === 'textarea' ? (
                <div className="textarea-container">
                  <textarea
                    id={currentStep.inputProps.name}
                    name={currentStep.inputProps.name}
                    value={formData[currentStep.inputProps.name] || ''}
                    onChange={handleChange}
                  />
                  <div className="emoji-container">
                    <button type="button" onClick={toggleEmojiList} className="emoji-toggle">
                      🙂
                    </button>
                    {isEmojiListVisible && <EmojiList onSelect={handleEmojiSelect} />}
                  </div>
                </div>
              ) : (
                <input
                  id={currentStep.inputProps.name}
                  name={currentStep.inputProps.name}
                  type={currentStep.inputProps.type}
                  value={formData[currentStep.inputProps.name] || ''}
                  onChange={handleChange}
                />
              )}
            </div>
            {error && <div className="form-feedback form-error">{error}</div>}
            {success && <div className="form-feedback form-success">{success}</div>}
            <div className="form-actions">
              <button type="button" onClick={handlePrevious} disabled={step === 0}>Voltar</button>
              <button type="button" onClick={() => { setIsCreating(false); setSelectedPilula(null); }}>Cancelar</button>
              {step < steps.length - 1 && (
                <button type="button" onClick={handleNext} disabled={!isContinueEnabled()}>
                  Continuar
                </button>
              )}
              {step === steps.length - 1 && (
                <button type="button" onClick={handleSubmit}>
                  {selectedPilula ? 'Atualizar Pílula' : 'Adicionar Pílula'}
                </button>
              )}
            </div>
          </form>
        </div>
      ) : (
        <>
          <div className="header-container">
            <h1>Pílulas Educacionais</h1>
            <div>
              <button onClick={() => setIsCreating(true)} className="add-button">Adicionar</button>
              <button onClick={openImportPillsModal} className="add-button">Importar</button>
              <button onClick={openEnviarPilulaModal} className="add-button">Processar Fila</button>
            </div>
          </div>

          <div className="search-container">
            <input
              type="text"
              className="search-input"
              placeholder="Buscar por título ou ID"
              value={searchQuery}
              onChange={handleSearch}
            />
            <FcSearch size="30" className="search-icon" />
          </div>

          {(searchQuery.trim() ? filteredPilulas : pilulas).length > 0 ? (
            <>
              <PilulaList
                pilulas={filteredPilulas} 
                setPilulas={setFilteredPilulas}
                currentPage={currentPage}
                itemsPerPage={ITEMS_PER_PAGE}
                onEdit={handleEdit}
                onDelete={handleDelete}
              />
              {selectedPilula && <PilulaDetails pilula={selectedPilula} />}
            </>
          ) : (
            <p>Nenhuma pílula encontrada.</p>
          )}

        </>
      )}

      {isModalVisible && (
        <ConfirmationModal
          onConfirm={handleDelete}
          onCancel={handleCancelDelete}
          message="Confirme a exclusão da pílula."
        />
      )}

<Modal
  isOpen={isEnviarPilulaModalVisible}
  onRequestClose={closeEnviarPilulaModal}
  contentLabel="Enviar Pílula"  
  style={{
    content: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      width: '50%',
      maxWidth: '400px',
      height: 'auto',
      padding: '20px',
      borderRadius: '10px',
      backgroundColor: '#f9f9f9',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      zIndex: 1000,
    },
  }}
>
  <EnviarPilula onCancel={closeEnviarPilulaModal} />  
</Modal>

    </div>
  );
}

export default Pilulas;
